import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonMuiTable, { Table } from "../../Component/Table/Table";
import { edit_icon } from "../../assets/img";
import Footer from "../../Component/Footer/Footer";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import useStore from "../redux/store/useStore";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";
import { MaskIcon } from "../../Component/MaskIcon";

const Role = () => {
  const navigate = useNavigate();
  const { user } = useStore();
  const { kv, set } = useStoreKv();
  const Roles = kv.roles || [];


  const [page, setPage] = useState(1);

  const [pagination, setPagination] = useState("");
  const [loader, setLoader] = useState(false);


  const [owners, setOwners] = useState(Roles);

  const getRoleList = async () => {
    if (!kv.roles || kv.roles.length === 0) {
      setLoader(true)
    }

    if (user?.id) {
      const res = await get(URLS.ADMINLIST);
      // console.log("res roles list", res);
      if (res.status === "success") {
        setOwners(res?.data);
        set('roles', res?.data);
        setLoader(false)
      } else {
        setOwners([]);
        set('roles', []);
        setLoader(false);
      }
    }
  }

  useEffect(() => {
    getRoleList();
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{row.index + 1}</p>;
        },
      },
      {
        Header: "Admin Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Role",
        accessor: "role",
        Cell: ({ value, row }) => {
          const data = row.original?.is_super_admin == true ? 'Super Admin' : 'Admin';
          return <p className="text-nowrap ac-text">{data}</p>;
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          const rowData = row.original;

          if (rowData.is_super_admin === true || rowData.id == user?.id) {
            return <span style={{ color: 'black', margin: "auto 23px" }}>-</span>;
          }
          return (
            <div className="d-flex ac-jc gap-3">
              {row.original.is_super_admin !== true ? (
                <button
                  onClick={() => {
                    navigate("/role-update", { state: { type: "edit", data: row.original } });
                  }}
                  className="cust-btn "

                >
                  <MaskIcon src={edit_icon} alt="" className=" editor-btn " />
                </button>
              ) : (<span style={{ color: 'black' }}>-</span>)}
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <div className="dashRightView ">
      <CustomScroll >
        <div className="container_overalls">
          <Table
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={owners}
            loading={loader}
            show={false}
          />
        </div>
        <Footer />
      </CustomScroll>
    </div>
  );
};

export default Role;
